import {SelectionModel} from '@angular/cdk/collections';
import {STEPPER_GLOBAL_OPTIONS} from '@angular/cdk/stepper';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {AfterViewChecked, ChangeDetectorRef, Component, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, FormGroupDirective, NgForm, Validators} from '@angular/forms';
import {ErrorStateMatcher, ThemePalette} from '@angular/material/core';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {MatPaginator} from '@angular/material/paginator';
import {MatTableDataSource} from '@angular/material/table';
import {Router} from '@angular/router';
import {userInfo} from 'os';
import {CountryServiceService} from 'src/app/country-service.service';
import {PDFfile} from 'src/app/device/PDFfile';
import {TraslateService} from 'src/app/traslate.service';
import {environment} from 'src/environments/environment';
import Swal from 'sweetalert2/dist/sweetalert2.js'
import {NgxSpinnerService} from 'ngx-spinner';
import {createPopper} from '@popperjs/core';

export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}


@Component({
  selector: 'app-companyuser',
  templateUrl: './companyuser.component.html',
  styleUrls: ['./companyuser.component.scss']
})
export class CompanyuserComponent implements OnInit, AfterViewChecked {
  dataSource: MatTableDataSource<any>;
  listItems: any[] = [];
  lengthSelected: number;
  IconOnItems: string;
  inputEt: boolean;
  linkrevendeur = decodeURI(this.router.url.split('/')[3].toString().replace("%20", " "))
  linkCompany = decodeURI(this.router.url.split('/')[4].toString().replace("%20", " "))
  hiddenItemClick: any = 0;
  id: any;
  city: any;
  name: any;
  email: any;
  gsm_number: any;
  created_at: any;
  expiration_date: any;
  activecheckbox: boolean;
  username: any;
  pageNum: any;
  manualPage: any;
  pageSize = 15;
  lengthpage: number;
  pageSizeOptions = [15, 30, 100];
  usercompany: boolean;
  usercompanyConnect: boolean;
  url: string;
  pageIndex: any = 0;
  users: any;
  filterValue: string = '';

  constructor(private http: HttpClient, private router: Router, public dialog: MatDialog, public traslateService: TraslateService, private spinnerusercompany: NgxSpinnerService, private cdRef: ChangeDetectorRef) {
  }

  displayedColumns: any[] = ['select', 'ID', 'statut', 'Nom', 'Prenom', 'Utilisateur', 'Date_de_creation', 'Derniere_connexion', 'Date_expiration', 'Active', 'Action'];
  displayedColumns1: any[] = ['select', 'ID', 'statut', 'Nom', 'Prenom', 'Utilisateur', 'Date_de_creation', 'Derniere_connexion', 'Date_expiration', 'Active'];
  @ViewChild('paginator', {static: true}) paginator: MatPaginator;
  selection = new SelectionModel<any>(true, []);

  ngOnInit(): void {
    //console.log(this.router.url)


    this.getCompanieUser()
  }

  pageChanged(event) {
    this.pageIndex = event.pageIndex;
    const pageSize = event.pageSize;
    const previousIndex = event.previousPageIndex;
    const previousSize = pageSize * this.pageIndex;
    this.getNextData(previousSize, (this.pageIndex + 1).toString());
  }

  getNextData(currentSize, offset) {
    const headerDict = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
    }
    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };
    this.url = environment.apiUrl + '/companies/' + this.router.url.split('/')[5] + '/users?name=' + this.filterValue + '&page=' + offset;
    this.http.get(this.url, requestOptions).subscribe((response: any) => {
      let list = response.data;
      list.length = response.total;
      this.users.length = currentSize;
      this.users.push(...list);
      this.dataSource = new MatTableDataSource([]);
      this.users.length = response.total;
      this.dataSource = new MatTableDataSource<any>(this.users);
      this.dataSource._updateChangeSubscription();
      this.dataSource.paginator = this.paginator;
    });
  }

  getCompanieUser() {
    const headerDict = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
    }

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };
    this.usercompany = true
    this.spinnerusercompany.show();
    this.http.get(environment.apiUrl + '/companies/' + this.router.url.split('/')[5] + '/users', requestOptions)
      .subscribe((response: any) => {
        this.users = response.data
        this.users.length = response.total
        this.dataSource = new MatTableDataSource<any>(this.users);
        this.dataSource.paginator = this.paginator;
        this.spinnerusercompany.hide();
        this.usercompany = false
      })
  }

  async getItemsbyClick() {

    this.lengthSelected = this.listItems.length
    //console.log(this.listItems.length)


    this.lengthSelected = this.listItems.length
    //console.log(this.listItems.length)
    this.lengthSelected = this.listItems.length
    //console.log(this.listItems.length)

    for (let entry of this.listItems) {

      this.id = entry.id
      this.name = entry.name
      this.email = entry.email
      this.gsm_number = entry.gsm_number
      this.created_at = entry.created_at
      this.expiration_date = entry.expiration_date
      this.city = entry.city
      this.username = entry.username

    }


    const {value: formValues} = await Swal.fire({

      imageUrl: "https://i.pinimg.com/originals/11/df/2b/11df2bc889722dab6946142dc9c70151.gif",
      imageSize: '600x600',
      confirmButtonText: 'OK!',


      html:

        '<h1 class="pb-4" style="color :#3b5876;" > <strong> Details user selected </strong>   <h1>' +
        '<h2 style="color :#3b5876;" > <strong> Nom de compte :</strong>  ' + this.username + ' <h2>' +
        '<h2 style="color :#3b5876;" > <strong> Nom :</strong>  ' + this.name + ' <h2>' +
        '<h2 style="color :#3b5876;" ><strong> Email : </strong> ' + this.email + ' <h2>' +
        '<h2 style="color :#3b5876;" ><strong> Numéro Téléphone  : </strong> ' + this.gsm_number + ' <h2>'


    })

    this.dataSource.paginator = this.paginator;


  }


  public updateManualPage(index): void {
    //console.log(index)
    this.pageNum = index
    this.manualPage = index;
    this.paginator.pageIndex = index;

    this.paginator.page.next({
      pageIndex: this.paginator.pageIndex,
      pageSize: this.paginator.pageSize,
      length: this.paginator.length
    });


  }


  collection: any;

  public updateManualPage2(index2): void {
    this.collection = []

    this.paginator.pageSize = index2

    this.paginator.page.next({
      pageIndex: this.paginator.pageIndex,
      pageSize: this.paginator.pageSize,
      length: this.paginator.length
    });


    this.lengthpage = parseInt("" + this.paginator.length / index2)


    //Create dummy data
    for (var i = 0; i < this.lengthpage + 1; i++) {
      this.collection.push(i + 1);
    }

//console.log(this.collection)
  }

  getgogo() {

    localStorage.setItem('numberItems', this.selection.selected.length.toString());
    this.hiddenItemClick = localStorage.getItem("numberItems")
    //console.log(this.hiddenItemClick)
    if (this.hiddenItemClick != 0) {
      this.activecheckbox = true
    }
  }

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.dataSource.data.forEach(row => this.selection.select(row));
  }

  /** The label for the checkbox on the passed row */
  checkboxLabel(row?: any): string {

    if (!row) {
      return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
    }
    this.listItems = this.selection.selected
    this.lengthSelected = this.listItems.length
    ////console.log(this.lengthSelected)
    if (this.lengthSelected == 1) {

      this.IconOnItems = 'ctive'

      //this.IconOnn =true
      //( <HTMLInputElement> document.getElementById("Button") ).disabled = false;
      this.inputEt = false
    }

    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.id + 1}`;
  }

  applyFilter(event: Event) {

    this.filterValue = (event.target as HTMLInputElement).value;
    const headerDict = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
    }

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };
    this.url = environment.apiUrl + '/companies/' + this.router.url.split('/')[5] + '/users?name=' + this.filterValue;
    this.http.get(this.url, requestOptions).subscribe((response: any) => {
      this.users = response.data
      this.users.length = response.total;
      this.dataSource = new MatTableDataSource(this.users)
      this.dataSource = new MatTableDataSource(this.users)
      this.paginator.pageIndex = 0;
      this.dataSource.paginator = this.paginator
    });

  }

  dbclickobjtdetailsuser: any = {};

  async dblclickdetails(select) {
    // console.log("dblclickdetails dblclickdetails dblclickdetails")
    // console.log(select);
    this.lengthSelected = this.listItems.length
    //console.log(this.listItems.length)


    this.lengthSelected = this.listItems.length
    //console.log(this.listItems.length)
    this.lengthSelected = this.listItems.length
    //console.log(this.listItems.length)

    // for (let entry of this.listItems) {

    // this.id = entry.id
    // this.name = entry.name
    // this.email = entry.email
    // this.gsm_number = entry.gsm_number
    // this.created_at = entry.created_at
    // this.expiration_date = entry.expiration_date
    // this.city = entry.city
    // this.username =entry.username

    // }


    this.id = select.id
    this.name = select.name
    this.email = select.email
    this.gsm_number = select.gsm_number
    this.created_at = select.created_at
    this.expiration_date = select.expiration_date
    this.city = select.city
    this.username = select.username


    const {value: formValues} = await Swal.fire({

      imageUrl: "https://i.pinimg.com/originals/11/df/2b/11df2bc889722dab6946142dc9c70151.gif",
      imageSize: '600x600',
      confirmButtonText: 'OK!',


      html:

        '<h1 class="pb-4" style="color :#3b5876;" > <strong> Details user selected </strong>   <h1>' +
        '<h2 style="color :#3b5876;" > <strong> Nom de compte :</strong>  ' + this.username + ' <h2>' +
        '<h2 style="color :#3b5876;" > <strong> Nom :</strong>  ' + this.name + ' <h2>' +
        '<h2 style="color :#3b5876;" ><strong> Email : </strong> ' + this.email + ' <h2>' +
        '<h2 style="color :#3b5876;" ><strong> Numéro Téléphone  : </strong> ' + this.gsm_number + ' <h2>'


    })

    this.dataSource.paginator = this.paginator;


  }

  arr: any = []

  deleteUser(operation, id) {
    if (operation == 'oneItem') {
      this.selection.clear()
      this.listItems = []
      this.arr = []
      this.listItems.push({
        id: id,
      })
    }

    for (var i = 0; i < this.listItems.length; i++) {
      var obj = {}; // <---- Move declaration inside loop

      obj['id'] = this.listItems[i].id;

      this.arr.push(this.listItems[i].id);
    }
    Swal.fire({
      title: "Voulez-vous supprimer ce utilisateur?",
      showCancelButton: true,
      allowOutsideClick: false,
      confirmButtonColor: '#262756',
      cancelButtonColor: "#e05a61",
      confirmButtonText: 'Oui',
      cancelButtonText: 'Annuler'
    }).then((result) => {
      if (result.isConfirmed) {
        this.usercompany = true
        this.spinnerusercompany.show();
        this.http.delete(environment.apiUrl + '/users/' + JSON.stringify(this.arr)).subscribe((response) => {
          var statusNumber: any = response

          if (statusNumber.status == 200) {
            Swal.fire({
              title: response["message"],
            },)

            this.getCompanieUser()
            this.spinnerusercompany.hide()
            this.usercompany = false
            this.selection.clear();

            this.hiddenItemClick = 0
            this.listItems = []
            this.arr = []

          } else {
            this.spinnerusercompany.hide()
            this.usercompany = false
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: statusNumber.message.join('<br>'),

            })
          }


        })

      } else {
        this.arr = []
        this.listItems = []
        this.selection.clear()
      }
    })


  }

  exportDeviceTablePDF() {
    Swal.fire({
      title: 'Souhaitez-vous  exporter la table type PDF?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Start export file!',
      cancelButtonText: 'No, keep it'
    }).then((result) => {
      if (result.value) {


        PDFfile.exportToPdf("ExampleTableusercompany", "tbl");

      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire(
          'Cancelled',
          'file not exported :)',
          'error'
        )
      }
    })


  }

  addCompanyUser() {


    this.dialog.open(AddCompanyUser, {

      data: {
        animal: 'panda'
      },
      disableClose: true,
      width: '50%',
      autoFocus: false,
      panelClass: 'my-custom-dialog-class'
    });


  }


  updateCompanyUser(operation, user) {


    let dialogRef = this.dialog.open(UpdateCompanyUser, {

      data: {
        animal: 'panda'
      },
      disableClose: true,
      width: '50%',
      autoFocus: false,
      panelClass: 'my-custom-dialog-class'
    });
    if (operation == 'oneItem') {
      this.selection.clear()
      this.listItems = []
      this.arr = []
      this.listItems.push(user)
    }
    this.traslateService.urlcompanyuserQuote.next(this.listItems)
    dialogRef.afterClosed().subscribe(result => {
      this.selection.clear()
      this.listItems = []
      this.arr = []

    });
  }


  exportDeviceTable(exportDirective, typeFile) {

    Swal.fire({
      title: 'Souhaitez-vous  exporter la table type ' + typeFile + ' ?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Start export file!',
      cancelButtonText: 'No, keep it'
    }).then((result) => {
      if (result.value) {
        Swal.fire(
          'Export!',
          'file is exported.',
          'success'
        )
        //console.log(exportDirective);
        exportDirective.exportTable(typeFile)
        /* var filename ='incoming message'

        const workSheet = XLSX.utils.json_to_sheet(this.dataSource.data, {header:["A","B","C","D","E","F",""], skipHeader:false});
        const workBook: XLSX.WorkBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workBook, workSheet, 'SheetName');
        XLSX.writeFile(workBook, filename+new Date()+'.xlsx'); */


        // For more information about handling dismissals please visit
        // https://sweetalert2.github.io/#handling-dismissals
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire(
          'Cancelled',
          'file not exported :)',
          'error'
        )
      }
    })

  }


  connectUser(e, e1, e2) {

    const headerDict = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
    }

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };
    this.spinnerusercompany.show()
    this.usercompanyConnect = true
    this.http.get(environment.apiUrl + '/users/loginAs/' + e, requestOptions).subscribe((user) => {
      //console.log(user)
      var statusConnect: any = user
      if (statusConnect.status == 200) {

        Swal.fire({
          position: 'center',
          title: 'Connexion établie',
          text: "Vous êtes maintenant connecté en tant que " + e1,
          showCancelButton: false,
          confirmButtonColor: '#262756',
          confirmButtonText: 'Se connecter',
          allowOutsideClick: true
        }).then((result) => {
          localStorage.setItem('startDateValue', new Date().toString())
          localStorage.setItem('endDateValue', new Date().toString())
          if (result.isConfirmed) {
            localStorage.setItem('currentAdmin', localStorage.getItem('currentUser'));
            localStorage.setItem('currentUser', JSON.stringify(statusConnect.message));
            //console.log(localStorage.getItem('currentUser'))
            this.spinnerusercompany.hide()
            this.usercompanyConnect = false
            window.location.href = "user/vehicule"
          }else{
            this.spinnerusercompany.hide()
            this.usercompanyConnect = false
            this.selection.clear();
          }
        })
      } else if (statusConnect.status == 500) {
        this.spinnerusercompany.hide()
        this.usercompanyConnect = false
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: statusConnect.message,

        })


      }


    })


  }

  clicksweet() {
    window.location.href = "device"
  }

  ngAfterViewChecked(): void {
    this.cdRef.detectChanges();
  }

}


export interface Task {
  name: string;
  completed: boolean;
  color: ThemePalette;
  subtasks?: Task[];
}

@Component({
  selector: 'addCompanyUser',
  templateUrl: 'addCompanyUser.html',
  styleUrls: ['./companyuser.component.scss'],
  providers: [{
    provide: STEPPER_GLOBAL_OPTIONS, useValue: {showError: true}
  }]
})
export class AddCompanyUser {
  hide = true;
  hide2 = true;
  countryInfo: any[] = [];
  cityInfo: any[] = [];
  county: any;
  city: any;
  stateInfo: any;
  addusercompany: boolean;
  block: any = 0;
  notBlock: any = 1;

  constructor(public dialogRef: MatDialogRef<AddCompanyUser>, private router: Router, private _formBuilder: FormBuilder, public traslateService: TraslateService, private http: HttpClient, private formBuilder: FormBuilder, private countryService: CountryServiceService, private spinnerusercompany: NgxSpinnerService) {
    this.getCountries()
  }


  getCountries() {
    this.countryService.allCountries().subscribe(
      data2 => {
        this.countryInfo = data2.Countries;
        ////console.log('Data:', this.countryInfo);
      },
      err => console.log(err),
      () => console.log('complete')
    )
  }

  onChangeCountry(countryValue) {
    //console.log('kjhkjhjk'+countryValue)

    //console.log(countryValue.value)
    //console.log('pays'+this.countryInfo[countryValue.value].Country)
    this.stateInfo = this.countryInfo[countryValue.value].States;
    this.cityInfo = this.stateInfo[0].Cities;
    //console.log('lkhkjlkjlkj,lkjkl'+JSON.stringify(this.countryInfo));
  }

  // tslint:disable-next-line:member-ordering
  registerForm: FormGroup = this.formBuilder.group({
      // tslint:disable-next-line:quotemark
      username: [, {validators: [Validators.required], updateOn: "change"}],
      first_name: ['', {validators: [Validators.pattern(/^[a-zA-Z][a-zA-Z\s]+$/)], updateOn: "change"}],
      last_name: [, {validators: [Validators.required, Validators.pattern(/^[a-zA-Z][a-zA-Z\s]+$/)], updateOn: "change"}],
      gsm_number: ['', {
        validators: [

          Validators.pattern("^[0-9]*$"),

        ], updateOn: "change"
      }],
      email: ['', {validators: [Validators.email], updateOn: "change"}],
      lang: [],
      city: [],
      country: [],
      password: [, {validators: [Validators.required], updateOn: "change"}],
      passwordConfirm: [, {validators: [Validators.required], updateOn: "change"}],
      expiration_date: [],
      is_active: []
    },
    {
      validators: ConfirmedValidator('password', 'passwordConfirm')
    });


  submitForm() {

    //console.log('LKLK'+this.registerForm);

    Object.values(this.registerForm).forEach(val => {
      //console.log(val);
    });

    const headerDict = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
    }

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };
    this.addusercompany = true
    this.spinnerusercompany.show()

    this.http.post(environment.apiUrl + '/companies/' + this.router.url.split('/')[5] + '/users', this.registerForm.value, requestOptions).subscribe(data => {
      var statusNumber: any = data
      //console.log(environment.apiUrl+'/companies/'+this.router.url.split('/')[5]+'/users')
      //console.log(statusNumber)
      // location.reload()
      if (statusNumber.status == 200) {
        Swal.fire({
          position: 'center',
          title: 'Utilisateur enregistré avec succès!',
          showConfirmButton: false,
          timer: 1000
        },)

        this.spinnerusercompany.hide()
        this.addusercompany = false
        window.location.reload();
      } else {
        //console.log('500 status')
        this.spinnerusercompany.hide()
        this.addusercompany = false
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: statusNumber.message.join('<br>'),

        })

      }
    })


  }

  task: Task = {
    name: 'Admin',
    completed: false,
    color: 'primary',
    subtasks: [
      {name: 'Admin_droit', completed: false, color: 'primary'},
      {name: 'Admin_droit', completed: false, color: 'accent'},
      {name: 'Admin_droit', completed: false, color: 'warn'}
    ]
  };

  allComplete: boolean = false;

  updateAllComplete() {
    this.allComplete = this.task.subtasks != null && this.task.subtasks.every(t => t.completed);
    //console.log(this.allComplete +'dfsk')
  }

  someComplete(): boolean {
    if (this.task.subtasks == null) {
      return false;
    }
    return this.task.subtasks.filter(t => t.completed).length > 0 && !this.allComplete;
  }

  setAll(completed: boolean) {
    this.allComplete = completed;
    if (this.task.subtasks == null) {
      return;
    }
    this.task.subtasks.forEach(t => t.completed = completed);
  }

  matcher = new MyErrorStateMatcher();

  closeDialog() {
    this.dialogRef.close();
  }
}


@Component({
  selector: 'updateCompanyUser',
  templateUrl: 'updateCompanyUser.html',
  styleUrls: ['./companyuser.component.scss'],
  providers: [{
    provide: STEPPER_GLOBAL_OPTIONS, useValue: {showError: true}
  }]
})
export class UpdateCompanyUser {
  hide = true;
  hide2 = true;
  url: any;
  id: any;
  username: any;
  first_name: any;
  last_name: any;
  gsm_number: any;
  email: any;
  name: any;
  countryInfo: any[] = [];
  cityInfo: any[] = [];
  county: any;
  city: any;
  stateInfo: any;
  lang: any;
  country: any;
  expiration_date: any;
  updateusercompany: boolean;
  checkbox: string;
  is_active: any;

  constructor(public dialogRef: MatDialogRef<AddCompanyUser>, private _formBuilder: FormBuilder, public traslateService: TraslateService, private http: HttpClient, private formBuilder: FormBuilder, private countryService: CountryServiceService, private spinnerusercompany: NgxSpinnerService) {
  }

  getCountries() {
    this.countryService.allCountries().subscribe(
      data2 => {
        this.countryInfo = data2.Countries;
        console.log('Data:', this.countryInfo);
      },
      err => console.log(err),
      () => console.log('complete')
    )
  }

  onChangeCountry(countryValue) {
    console.log('101010    ', countryValue.value)

    //console.log(countryValue.value)
    //console.log('pays'+this.countryInfo[countryValue.value].Country)
    this.stateInfo = this.countryInfo[countryValue.value].States;
    this.cityInfo = this.stateInfo[0].Cities;
    console.log('101010000000000000' + this.stateInfo)

    //console.log('lkhkjlkjlkj,lkjkl'+JSON.stringify(this.countryInfo));
  }

  ngOnInit(): void {
    this.getCountries()
    this.traslateService.currentcompanyuserQuote.subscribe(data => {
      this.url = data
      console.log(this.url)
      this.countryService.allCountries().subscribe(
        (data2): any => {
          this.stateInfo = data2.Countries[this.url[0].country].States;
        },
      )
    })

    for (let entry of this.url) {
      this.id = entry.id
      this.username = entry.username
      this.first_name = entry.first_name
      this.last_name = entry.last_name
      this.gsm_number = entry.gsm_number
      this.email = entry.email
      this.name = entry.name
      this.lang = entry.lang
      this.city = entry.city
      this.country = entry.country
      this.expiration_date = entry.expiration_date
      this.is_active = entry.is_active
    }
  }

  // tslint:disable-next-line:member-ordering
  registerForm: FormGroup = this.formBuilder.group({
      // tslint:disable-next-line:quotemark
      username: [, {validators: [Validators.required], updateOn: "change"}],
      first_name: ['', {validators: [Validators.pattern(/^[a-zA-Z][a-zA-Z\s]+$/)], updateOn: "change"}],
      last_name: [, {validators: [Validators.required, Validators.pattern(/^[a-zA-Z][a-zA-Z\s]+$/)], updateOn: "change"}],
      gsm_number: ['', {
        validators: [

          Validators.pattern("^[0-9]*$"),

        ], updateOn: "change"
      }],
      lang: [],
      city: [],
      country: [],
      email: ['', {validators: [Validators.email], updateOn: "change"}],
      password: [, {validators: [], updateOn: "change"}],
      passwordConfirm: [, {validators: [], updateOn: "change"}],
      expiration_date: [],
      is_active: []
    },
    {
      validators: ConfirmedValidator('password', 'passwordConfirm')
    });

  submitForm() {
  }

  task: Task = {
    name: 'Admin',
    completed: false,
    color: 'primary',
    subtasks: [
      {name: 'Admin_droit', completed: false, color: 'primary'},
      {name: 'Admin_droit', completed: false, color: 'accent'},
      {name: 'Admin_droit', completed: false, color: 'warn'}
    ]
  };


  allComplete: boolean = false;

  updateAllComplete() {
    this.allComplete = this.task.subtasks != null && this.task.subtasks.every(t => t.completed);
    //console.log(this.allComplete +'dfsk')
  }

  someComplete(): boolean {
    if (this.task.subtasks == null) {
      return false;
    }
    return this.task.subtasks.filter(t => t.completed).length > 0 && !this.allComplete;
  }

  setAll(completed: boolean) {
    this.allComplete = completed;
    if (this.task.subtasks == null) {
      return;
    }
    this.task.subtasks.forEach(t => t.completed = completed);
  }

  matcher = new MyErrorStateMatcher();

  closeDialog() {
    this.dialogRef.close();
  }

  submitFormUpdate(e) {

    //console.log('LKLK'+this.registerForm);

    Object.values(this.registerForm).forEach(val => {
      //console.log(val);
    });


    const headerDict = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
    }

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };
    this.updateusercompany = true
    this.spinnerusercompany.show()
    this.http.put(environment.apiUrl + '/users/' + e, this.registerForm.value, requestOptions).subscribe(response => {
      //console.log(response)
      var resp: any = response
      if (resp.status == 200) {
        Swal.fire({
          position: 'center',
          title: 'Modification enregistré avec succès!',
          showConfirmButton: false,
          timer: 1000
        },)
        this.spinnerusercompany.hide()
        this.updateusercompany = false
        location.reload()
      } else {
        this.spinnerusercompany.hide()
        this.updateusercompany = false
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: resp.message.join('<br>'),

        })
      }
    })


  }
}

export function ConfirmedValidator(controlName: string, matchingControlName: string) {
  return (formGroup: FormGroup) => {
    const control = formGroup.controls[controlName];
    const matchingControl = formGroup.controls[matchingControlName];
    if (matchingControl.errors && !matchingControl.errors.confirmedValidator) {
      return;
    }
    if (control.value !== matchingControl.value) {
      matchingControl.setErrors({confirmedValidator: true});
    } else {
      matchingControl.setErrors(null);
    }
  }
}
